import axios from 'axios'
import { HOST } from './../constants/url'
import { getQueryString, trimStrings } from '../helper/common'
import { SessionStorageManager, LocalStorageManager } from './../helper/localStorage'
import { decryptAes256CBC, encryptAes256CBC } from './../pageUtililiy/EncryptionFunctions'
import { PARAM_APIKEY } from '../constants/params'

function send({ method = 'get', path, data = null, query = null, headers = {}, newUrl, token }) {
  return new Promise((resolve) => {
    let _query = {
      ...query,
      apikey: SessionStorageManager.getItem(PARAM_APIKEY) || process.env.REACT_APP_APIKEY
    }
    let url = HOST + `${path}${getQueryString(_query)}`
    if (newUrl) {
      url = `${newUrl}${getQueryString(_query)}`
    }
    let getToken
    if (token === false) {
      getToken = false
    } else {
      let sdkToken = null
      try {
        const storedUser = LocalStorageManager.getItem('trafficFineConfirmedUserData')
        if (storedUser) {
          sdkToken = storedUser?.sdkToken
        }
      } catch (e) {}

      getToken = token || sdkToken || window.localStorage.getItem('BHXM_token')
    }
    if (getToken) {
      headers.authorization = `Bearer ${getToken}`
    }

    let encryption = data
    if (data && process.env.REACT_APP_RUNTIME_MODE === 'production') {
      let newObj = {}
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          newObj[process.env.REACT_APP_KEY_PAYLOAD + key] = data[key]
        }
      }
      const newStringData = JSON.stringify(trimStrings(newObj))
      encryption = encryptAes256CBC(newStringData)
    }

    axios({
      method,
      url,
      data: encryption,
      headers
    })
      .then((result) => {
        let data = result.data
        let decryption = data
        if (data.idEn) {
          decryption = JSON.parse(decryptAes256CBC(data)) // mã hoá lấy về
          data = decryption
        }
        return resolve(data)
      })
      .catch((error) => {
        const { response = {} } = error
        const result = response.data ? response.data : null
        if (!result) {
          // Không có response => mất kết nối internet / server không phản hồi
          return resolve({
            statusCode: 500,
            isNetworkError: true,
            message: 'Unknown error'
          })
        } else {
          const { statusCode, message: data } = result

          if (statusCode === 401) {
            // setTimeout(() => {
            //   cleanUp()
            // }, 1000)
            return resolve(result)
          } else if ((statusCode === 401 && data === 'Unauthorized') || (statusCode === 403 && data === 'InvalidToken')) {
            // cleanUp()
            return resolve(result)
          } else if (statusCode === 505) {
            return resolve(result)
          } else if (statusCode === 500) {
            return resolve(result)
          } else {
            return resolve(result)
          }
        }
      })
  })
}

const requestService = {
  send
}

const requestServiceInstance = requestService

export default requestServiceInstance
